var map = {
	"./CN.png": [
		1186,
		4
	],
	"./ID.png": [
		1187,
		5
	],
	"./MY.png": [
		1188,
		6
	],
	"./SG.png": [
		1189,
		7
	],
	"./TH.png": [
		1190,
		8
	],
	"./US.png": [
		1191,
		9
	],
	"./VN.png": [
		1192,
		10
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 235;
module.exports = webpackAsyncContext;